import React from 'react';
import { Link } from 'react-router-dom';

const SiteList = ({token, sites}) => {
  if (!token) {
    return null;
  }

  let recentFive = [];
  if(sites) {
    sites = sites.sort((a, b) => {
      return (a.modifiedAt > b.modifiedAt ? -1 : 1);
    });
    sites.forEach(site => {
      if(recentFive.length < 5) {
        recentFive.push(site);
      }
    });
  }

  return (
    <div className="col-md-3">
      {token && sites && 
        <div className="sidebar text-center">
          <Link to={'/sites/new'} className="btn btn-warning">Create New Site</Link>
          <hr/>
          <h5 className="text-left">Recent Sites</h5>
          <hr/>
          <ul className="recent-list">
            {recentFive.map((site) => <li className="recent-list-item" key={site.id}><Link to={'/sites/'+site.id+'/view'} className="">{site.id}</Link></li> )}
          </ul>
        </div>
      }
    </div>
  );

};

export default SiteList;
